import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userEmail: "",
  isUserDeviceAuthenticated: false,
  error: null,
};

export const deviceAuthSlice = createSlice({
  name: "deviceAuth",
  initialState,
  reducers: {
    deviceAuthenticationSuccessful: (state, action) => {
      state.userEmail = action.payload.email;
    },
  },
});

export const { deviceAuthenticationSuccessful } = deviceAuthSlice.actions;
export default deviceAuthSlice.reducer;